import Icon from '@jetbrains/icons/comment.svg'
import classNames from 'classnames'
import * as React from 'react'

import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'

import styles from './CommentIcon.css'

function CommentIcon({className}: {className?: string}) {
  return <SvgIcon className={classNames(styles.commentIcon, className)} icon={Icon} />
}

export default CommentIcon
